export const padWithLeadingZeroes = (idOrPzn, minLength = 8) => {
  return idOrPzn.padStart(minLength, '0')
}
